"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.osmosysAppUpdateDefault = {
    switchAdminRole: () => { },
    updateOsmosysContext: () => { },
};
exports.OsmosysAppUpdateContext = react_1.default.createContext(exports.osmosysAppUpdateDefault);
//# sourceMappingURL=OsmosysAppUpdateContext.js.map